module.exports = __webpack_public_path__ + "img/pr-1.27e3fa26.png";